import { useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { OptionsList } from 'components/core/form'
import { SearchableSelectField } from 'components/core/form/searchable-select-field/raw/searchable-select-field'
import { changeOwnerMembersSelector, changeOwnerLoadingSelector } from 'features/account_settings/selectors'
import { fetchMemberships } from 'features/account_settings/slice'

import { Row } from './shared'

export const ChangeOwnerDropdown = () => {
  const dispatch = useDispatch()
  const members = useSelector(changeOwnerMembersSelector)
  const isLoading = useSelector(changeOwnerLoadingSelector)
  const [{ value: newOwnerId }, meta, { setValue }] = useFormField('newOwnerId')
  const selectedOwnerName = newOwnerId && members.find(({ user_id: userId }) => userId === newOwnerId).name

  useEffect(() => {
    dispatch(fetchMemberships())
  }, [dispatch])

  const handleChange = (selectedMemberId) => {
    const selectedOwner = members.find(({ id }) => id === selectedMemberId)

    setValue(selectedOwner.user_id)
  }

  const handleSearch = useCallback((query) => {
    dispatch(fetchMemberships(query))
  }, [dispatch])

  return (
    <>
      <Row>
        {I18n.t('publisher.account_settings.profile.delete_account.popup.choose_new')}
        *
      </Row>
      <SearchableSelectField
        name="choose_a_new_owner"
        aria-label={I18n.t('publisher.account_settings.profile.delete_account.popup.choose_new')}
        options={members.filter(({ role }) => role !== 'owner')}
        placeholder={I18n.t('publisher.account_settings.profile.delete_account.popup.placeholder')}
        displayValue={selectedOwnerName}
        onChange={handleChange}
        onSearch={handleSearch}
        errors={meta.touched && meta.error ? [meta.error].flat() : []}
      >
        <OptionsList
          isLoading={isLoading}
          notFoundText={I18n.t('publisher.account_settings.profile.delete_account.popup.none_found')}
        />
      </SearchableSelectField>
    </>
  )
}
